module.exports = __webpack_public_path__ + "static/img/liriver.d8c8819.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/liriver.jpg
// module id = qHdV
// module chunks = 1